import { ChevronDown } from '@/shared/ui/Icon';
import type { FaqGroup } from '@/modules/tenant/domain/entities/tenant.entity';

/**
 * O FAQ da LP. Abre e fecha com `<details>`, e não com estado em React: o
 * conteúdo é estático, e o elemento nativo já traz o acordeão, o foco por
 * teclado e o estado de expandido.
 */
export function FaqSection({ groups }: { groups: FaqGroup[] }) {
  if (groups.length === 0) return null;

  return (
    <section className="fold fold-center" id="faq">
      <div className="wrap">
        <h2 className="claim">Perguntas frequentes</h2>

        <div className="faq">
          {groups.map((section) => (
            <div className="faq-group" key={section.group}>
              <h3 className="faq-group-title">{section.group}</h3>

              {section.items.map((item) => (
                <details className="faq-item" key={item.q}>
                  <summary className="faq-q">
                    <span>{item.q}</span>
                    <ChevronDown size="sm" className="faq-caret" />
                  </summary>
                  <p className="faq-a">{item.a}</p>
                </details>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
